import {combineReducers, Reducer} from 'redux'
import {TicketState} from '@models/ticket'
import {TicketsActionTypes} from '@actions/ticket';
import {TicketStatus} from "../models/ticket";


// Type-safe initialState!
export const initialState: TicketState = {
  allIds: [],
  byId: {},
  loading: false,
  count: 0,
  pendingTickets: 0
};


const getPendingTicketsDelta = (oldStatus, newStatus) => {
  if( (oldStatus == TicketStatus.PENDING) && (newStatus != TicketStatus.PENDING)){
    return -1;
  }
  else if( (oldStatus != TicketStatus.PENDING) && (newStatus == TicketStatus.PENDING)){
    return 1;
  }
  else{
    return 0
  }
};

const reducer: Reducer<TicketState> = (state = initialState, action) => {
  switch (action.type) {
    case TicketsActionTypes.FETCH_REQUEST: {
      return {
        ...state,
        loading: true
      }
    }
    
    case TicketsActionTypes.FETCH_SUCCESS: {
      const {data, meta} = action.payload;
      return {
        ...state,
        byId :{
          ...data.reduce((obj, ticket) => {
            obj[ticket.id] = {
              ...ticket,
              is_fetched: false,
              ...(state[ticket.id] || {}) //The data which fetch by id is more than data in Table
            };
            return obj;
          }, {})
        },
        allIds: data.map( item => item.id),
        loading: false,
        count: meta.total_count,
      }
    }
    
    case TicketsActionTypes.FETCH_PENDING_SUCCESS: {
      const {meta} = action.payload;
      return {
        ...state,
        pendingTickets: meta.total_count
      }
    }
    
    case TicketsActionTypes.FETCH_ERROR: {
      return {...state, loading: false, errors: action.payload.error}
    }
    
    case TicketsActionTypes.UPDATE_SUCCESS: {
      const updatedTicket = action.payload;
      const previousTicket = state.byId[updatedTicket.id];
      
      return {
        ...state,
        byId : {
          ...state.byId,
          [updatedTicket.id]: {
            ...previousTicket,
            ...updatedTicket
          },
        },
        pendingTickets : state.pendingTickets + getPendingTicketsDelta(previousTicket.status, updatedTicket.status )
      };
    }
    
    default: {
      return state
    }
  }
};

export {reducer as ticketReducer}


//Selectors
export const getTicketsList = tickets =>
  tickets.allIds.map(id => tickets.byId[id]);

export const getTicketById = (tickets, id) => tickets.byId[id];
